import React, { useCallback, useState } from 'react';
import { LayoutAnimation, Pressable, StyleSheet, Text, View } from 'react-native';
import { MaterialCommunityIcons } from '@expo/vector-icons';
import { REDESIGN_COLORS } from '../../styles/colors';
import ProBadge from '../common/ProBadge';

const CollapsibleSection = ({ title, defaultExpanded = true, children, onToggle, hideTopBorder = false, proGated = false }) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const handleToggle = useCallback(() => {
    LayoutAnimation.configureNext(LayoutAnimation.Presets.easeInEaseOut);
    const next = !isExpanded;
    setIsExpanded(next);
    if (onToggle) onToggle(title, next);
  }, [isExpanded, onToggle, title]);

  return (
    <View style={[styles.container, hideTopBorder && styles.noBorder]}>
      <Pressable style={styles.header} onPress={handleToggle}>
        <View style={styles.titleRow}>
          <Text style={styles.title}>{title.toUpperCase()}</Text>
          {proGated && <ProBadge />}
        </View>
        <MaterialCommunityIcons
          name={isExpanded ? 'chevron-up' : 'chevron-down'}
          size={20}
          color={REDESIGN_COLORS.textSecondary}
        />
      </Pressable>
      {isExpanded && <View style={styles.content}>{children}</View>}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingTop: 24,
    borderTopWidth: 1,
    borderTopColor: REDESIGN_COLORS.borderSubtle,
  },
  noBorder: {
    borderTopWidth: 0,
    paddingTop: 0,
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 10,
  },
  title: {
    fontFamily: 'Satoshi-Bold',
    fontSize: 12,
    letterSpacing: 1,
    color: REDESIGN_COLORS.textSecondary,
  },
  content: {
    marginTop: 24,
  },
});

export default CollapsibleSection;
